import { render } from "./app-dialog2.vue?vue&type=template&id=21dffe5e&scoped=true"
import script from "./app-dialog2.vue?vue&type=script&lang=js"
export * from "./app-dialog2.vue?vue&type=script&lang=js"

import "./app-dialog2.vue?vue&type=style&index=0&id=21dffe5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21dffe5e"]])

export default __exports__